export const colors = {
    textPrimary: '#0C96D7',
    bgcPrimary: '#333',
    white: '#fff',
    transparent: 'transparent',
    error: 'red',
    black: '#000',
    success: 'lightgreen',
    warning: 'yellow'
}